<template lang="pug">
el-input(
  v-bind="$attrs",
  v-model="model",
  :disabled="disabled",
  :clearable="clearable",
  @keyup.enter="emitEnter"
)
  template(#suffix)
    font-awesome-icon(:icon="['fas', 'qrcode']", @click="showQrCodeReader")
.qr-code-overlay.fixed.top-0.bottom-0.left-0.right-0.flex.z-10(
  v-if="qrScannerVisible"
)
  .absolute.background.bg-neutral-800.w-full.h-full.opacity-50
  .absolute.flex.w-full.h-full.justify-center.items-center.p-16
    .flex.flex-col
      .stream.h-96.max-w-full.mb-8.rounded.overflow-hidden
        QrcodeStream(@detect="onDetectQrCode")
      el-button(type="primary", @click="closeQrCode") {{ $t("cancel") }}
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { QrcodeStream } from "vue-qrcode-reader";

const props = defineProps<{
  modelValue?: string;
  disabled?: boolean;
  clearable?: boolean;
}>();

const emit = defineEmits(["update:modelValue", "enter"]);

const model = computed({
  get() {
    return props.modelValue || "";
  },
  set(val) {
    if (props.disabled) {
      return;
    }
    emit("update:modelValue", val);
  },
});

const qrScannerVisible = ref(false);

function showQrCodeReader() {
  if (props.disabled) {
    return;
  }
  qrScannerVisible.value = true;
}

function onDetectQrCode(code) {
  const value = code[0].rawValue;
  if (value) {
    model.value = value;
  }
  closeQrCode();
}

function closeQrCode() {
  qrScannerVisible.value = false;
}

function emitEnter() {
  emit("enter");
}
</script>
